export const menuItems = [
  // Breakfast & Brunch
  {
    id: 1,
    name: 'Avocado Toast Deluxe',
    category: 'breakfast',
    price: 14.50,
    description: 'Smashed avocado on sourdough with poached eggs, cherry tomatoes, and microgreens',
    image: 'https://images.unsplash.com/photo-1541519227354-08fa5d50c44d?w=600&q=80',
    dietary: ['vegetarian']
  },
  {
    id: 2,
    name: 'Fluffy Pancake Stack',
    category: 'breakfast',
    price: 12.00,
    description: 'Three buttermilk pancakes with maple syrup, fresh berries, and whipped cream',
    image: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=600&q=80',
    dietary: ['vegetarian']
  },
  {
    id: 3,
    name: 'Mediterranean Breakfast Bowl',
    category: 'breakfast',
    price: 15.00,
    description: 'Quinoa, roasted vegetables, hummus, feta, and soft-boiled egg',
    image: 'https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?w=600&q=80',
    dietary: ['vegetarian', 'gluten-free']
  },
  {
    id: 4,
    name: 'Vegan Breakfast Burrito',
    category: 'breakfast',
    price: 13.50,
    description: 'Scrambled tofu, black beans, avocado, salsa, and cashew cream',
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },

  // Starters & Small Plates
  {
    id: 5,
    name: 'Crispy Calamari',
    category: 'starters',
    price: 16.00,
    description: 'Lightly fried calamari with lemon aioli and marinara sauce',
    image: 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=600&q=80',
    dietary: ['dairy-free']
  },
  {
    id: 6,
    name: 'Mezze Platter',
    category: 'starters',
    price: 18.00,
    description: 'Hummus, baba ganoush, falafel, olives, and warm pita bread',
    image: 'https://images.unsplash.com/photo-1529006557810-274b9b2fc783?w=600&q=80',
    dietary: ['vegan', 'vegetarian']
  },
  {
    id: 7,
    name: 'Buffalo Cauliflower Wings',
    category: 'starters',
    price: 14.00,
    description: 'Crispy cauliflower tossed in buffalo sauce with ranch dip',
    image: 'https://images.unsplash.com/photo-1608039829572-78524f79c4c7?w=600&q=80',
    dietary: ['vegetarian', 'gluten-free']
  },

  // Mains (Wood-Fired & Signature Dishes)
  {
    id: 8,
    name: 'Wood-Fired Salmon',
    category: 'mains',
    price: 28.00,
    description: 'Atlantic salmon with roasted vegetables and lemon herb butter',
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=600&q=80',
    dietary: ['gluten-free', 'dairy-free']
  },
  {
    id: 9,
    name: 'Grilled Ribeye Steak',
    category: 'mains',
    price: 36.00,
    description: '12oz ribeye with garlic mashed potatoes and seasonal vegetables',
    image: 'https://images.unsplash.com/photo-1558030006-450675393462?w=600&q=80',
    dietary: ['gluten-free']
  },
  {
    id: 10,
    name: 'Mushroom Risotto',
    category: 'mains',
    price: 22.00,
    description: 'Creamy arborio rice with wild mushrooms, parmesan, and truffle oil',
    image: 'https://images.unsplash.com/photo-1476124369491-c4ca2e5e2a8f?w=600&q=80',
    dietary: ['vegetarian', 'gluten-free']
  },
  {
    id: 11,
    name: 'Vegan Buddha Bowl',
    category: 'mains',
    price: 19.00,
    description: 'Quinoa, roasted chickpeas, sweet potato, kale, and tahini dressing',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&q=80',
    dietary: ['vegan', 'gluten-free', 'dairy-free']
  },

  // Burgers & Sandwiches
  {
    id: 12,
    name: 'Classic Beef Burger',
    category: 'burgers',
    price: 17.00,
    description: 'Angus beef patty, lettuce, tomato, onion, pickles, and special sauce',
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=600&q=80',
    dietary: []
  },
  {
    id: 13,
    name: 'Impossible Burger',
    category: 'burgers',
    price: 16.00,
    description: 'Plant-based patty with all the classic toppings',
    image: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },
  {
    id: 14,
    name: 'Grilled Chicken Sandwich',
    category: 'burgers',
    price: 15.50,
    description: 'Marinated chicken breast, avocado, bacon, and chipotle mayo',
    image: 'https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=600&q=80',
    dietary: []
  },

  // Specialty Coffee & Tea
  {
    id: 15,
    name: 'Signature Espresso',
    category: 'coffee',
    price: 4.50,
    description: 'Single origin espresso from our wood-roasted beans',
    image: 'https://images.unsplash.com/photo-1510591509098-f4fdc6d0ff04?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },
  {
    id: 16,
    name: 'Vanilla Latte',
    category: 'coffee',
    price: 6.00,
    description: 'Espresso with steamed milk and vanilla syrup',
    image: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&q=80',
    dietary: ['vegetarian']
  },
  {
    id: 17,
    name: 'Matcha Green Tea Latte',
    category: 'coffee',
    price: 6.50,
    description: 'Premium matcha powder with steamed oat milk',
    image: 'https://images.unsplash.com/photo-1536013266905-d490d1b39a3e?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },
  {
    id: 18,
    name: 'Cold Brew Coffee',
    category: 'coffee',
    price: 5.50,
    description: 'Smooth 16-hour cold brew served over ice',
    image: 'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },

  // Fresh Juices & Beverages
  {
    id: 19,
    name: 'Green Detox Juice',
    category: 'beverages',
    price: 8.00,
    description: 'Kale, spinach, cucumber, apple, lemon, and ginger',
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=600&q=80',
    dietary: ['vegan', 'gluten-free', 'dairy-free']
  },
  {
    id: 20,
    name: 'Berry Smoothie Bowl',
    category: 'beverages',
    price: 11.00,
    description: 'Mixed berries, banana, granola, and coconut flakes',
    image: 'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },
  {
    id: 21,
    name: 'Fresh Orange Juice',
    category: 'beverages',
    price: 6.00,
    description: 'Freshly squeezed Valencia oranges',
    image: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=600&q=80',
    dietary: ['vegan', 'gluten-free', 'dairy-free']
  },

  // Desserts & Baked Goods
  {
    id: 22,
    name: 'Chocolate Lava Cake',
    category: 'desserts',
    price: 9.50,
    description: 'Warm chocolate cake with molten center and vanilla ice cream',
    image: 'https://images.unsplash.com/photo-1624353365286-3f8d62daad51?w=600&q=80',
    dietary: ['vegetarian']
  },
  {
    id: 23,
    name: 'New York Cheesecake',
    category: 'desserts',
    price: 8.50,
    description: 'Classic creamy cheesecake with berry compote',
    image: 'https://images.unsplash.com/photo-1533134486753-c833f0ed4866?w=600&q=80',
    dietary: ['vegetarian']
  },
  {
    id: 24,
    name: 'Vegan Chocolate Brownie',
    category: 'desserts',
    price: 7.00,
    description: 'Fudgy chocolate brownie with coconut ice cream',
    image: 'https://images.unsplash.com/photo-1607920591413-4ec007e70023?w=600&q=80',
    dietary: ['vegan', 'dairy-free']
  },
  {
    id: 25,
    name: 'Tiramisu',
    category: 'desserts',
    price: 9.00,
    description: 'Classic Italian dessert with espresso-soaked ladyfingers',
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=600&q=80',
    dietary: ['vegetarian']
  }
];